import { Table, Button } from "react-bootstrap";
import TablePaginationBar from "../components/TablePaginationBar";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { config } from "../config/config";
import { FaSearch } from "react-icons/fa";

const TagsListView = () => {
  const user = useSelector((state) => state?.user);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("tags");

  const navigate = useNavigate();
  const location = useLocation();

  const businessId = user?.user?.businessId;
  const businessIdentifier = user?.user?.businessIdentifier;

  const fetchTags = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/tags/list-tags?businessId=${businessId}&businessIdentifier=${businessIdentifier}`,
        config
      );
      console.log("🚀 ~ fetchTags ~ response:", response);
      
      // Handle the nested data structure correctly
      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        setTags(response.data.data);
      } else {
        setTags([]);
        console.warn("Unexpected API response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching tags:", error);
      toast.error("Failed to load tags.");
      setTags([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const handleCoreClick = () => {
    setActiveTab("core");
    navigate("/journeys");
  };
  
  const handleTagsClick = () => {
    setActiveTab("tags");
    navigate("/tags");
  };
  

  const handleView = (tag) => {
    navigate(`/tags/${tag.id}`, { state: { tag } });
  };

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Filter tags based on search term
  const filteredTags = tags.filter(tag =>
    tag.name.toLowerCase().includes(searchTerm.toLowerCase())
  );  

  // Get current tags
  const indexOfLastTag = currentPage * itemsPerPage;
  const indexOfFirstTag = indexOfLastTag - itemsPerPage;
  const currentTags = filteredTags.slice(indexOfFirstTag, indexOfLastTag);

  return (
    <div className="app-page">
      <div className="pill-tabs">
        <button
          type="button"
          className={`pill-tab ${location.pathname === "/journeys" ? "active" : ""}`}
          onClick={handleCoreClick}
        >
          Core
        </button>
        <button
          type="button"
          className={`pill-tab ${location.pathname === "/tags" ? "active" : ""}`}
          onClick={handleTagsClick}
        >
          Tags
        </button>
      </div>
      <div className="bg-white rounded shadow-sm" style={{ overflow: "hidden" }}>
        <div className="app-page-toolbar">
          <h2 className="app-page-title">Tags</h2>
          <div className="app-page-toolbar-filters">
            <div className="app-filter-search-wrap">
              <FaSearch className="app-filter-search-icon" />
              <input
                type="text"
                className="form-control app-filter-search"
                placeholder="Search by Name"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                style={{ width: "220px" }}
              />
            </div>
            <button
              className="app-filter-action-btn"
              onClick={() => navigate("/tags/add")}
            >
              Add New
            </button>
          </div>
        </div>

        <Table hover responsive className="mb-0">
          <thead
            style={{
              backgroundColor: "#064260",
              color: "white",
              height: "50px",
              textAlign: "center",
            }}
          >
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {loading ? (
              <tr>
                <td colSpan="4" className="text-center py-3">
                  Loading tags...
                </td>
              </tr>
            ) : currentTags.length > 0 ? (
              currentTags.map((tag, index) => (
                <tr key={tag.id}>
                  <td>
                  {tag.id.toString().padStart(4, "0")}
                  </td>
                  <td>{tag.name}</td>
                  <td>{tag.status ? tag.status.charAt(0).toUpperCase() + tag.status.slice(1) : "—"}</td>
                  <td>
                    <button className="app-view-btn" onClick={() => handleView(tag)}>
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-3">
                  No tags found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {filteredTags.length > 0 && (
          <TablePaginationBar
            currentPage={currentPage}
            totalItems={filteredTags.length}
            rowsPerPage={itemsPerPage}
            onPageChange={paginate}
            onRowsPerPageChange={(n) => {
              setItemsPerPage(n);
              setCurrentPage(1);
            }}
            rowsPerPageOptions={[10, 25, 50]}
          />
        )}
      </div>
    </div>
  );
};

export default TagsListView;